import { useEffect } from "react";
import { useParams } from "react-router-dom";

// Branded Creator Crew short links that resolve in-app (works on any host
// that serves the SPA fallback). Server-side _redirects also exist for when
// prod is fully on Cloudflare Pages; whichever fires first is fine.

const ontourhqUrl = (code: string) =>
  `https://events.ontourhq.com/e/yrd/tickets?utm_source=affiliate&utm_name=Creators&utm_campaign=Creators&utm_id=6a40868313f046eab62000150a1e60cb&promo=${encodeURIComponent(
    code
  )}&p=creator`;

const repostUrl = (c: string) =>
  `https://n8n-roostertail-u60710.vm.elestio.app/webhook/yrd-repost-click?c=${encodeURIComponent(
    c
  )}`;

const Splash = () => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0B1622",
      color: "#f7b41c",
      fontFamily: "system-ui, sans-serif",
      fontSize: "1.15rem",
      letterSpacing: "0.02em",
    }}
  >
    Setting sail… ⚓
  </div>
);

// /go/:code -> OnTourHQ tickets with the creator promo applied
export const GoRedirect = () => {
  const { code } = useParams();
  useEffect(() => {
    window.location.replace(ontourhqUrl(code || ""));
  }, [code]);
  return <Splash />;
};

// /repost/:c -> n8n (logs click, fires the 30-min code timer) -> Instagram post
export const RepostRedirect = () => {
  const { c } = useParams();
  useEffect(() => {
    window.location.replace(repostUrl(c || ""));
  }, [c]);
  return <Splash />;
};

// /recap + /recap-video -> 2025 recap film on Cloudflare Stream (used in
// creator outreach emails; same asset as the homepage hero and /creators).
const RECAP_WATCH_URL =
  "https://customer-izud1idylkfqkoa2.cloudflarestream.com/58bd12339bafa1040d9b189e120f6f57/watch";

export const RecapRedirect = () => {
  useEffect(() => {
    window.location.replace(RECAP_WATCH_URL);
  }, []);
  return <Splash />;
};

// /tradefirst -> Google Form where TradeFirst members reserve passes on trade
// (used in the TradeFirst email blasts).
const TRADEFIRST_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdz_Ts78irZ3qAKHx1GNOOpRMEUwith99R_evFVKs_oXVy-hw/viewform";

export const TradeFirstRedirect = () => {
  useEffect(() => {
    window.location.replace(TRADEFIRST_FORM_URL);
  }, []);
  return <Splash />;
};
